export interface TrackingSettingsResponseDto {
  id: string;
  companyId: string;
  ovmsItemId: number;
  ovmsStatus: 'active' | 'inactive';
}
